var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSocialsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 23,
    viewBox: "0 0 28 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 21.9299C26.5 19.6078 24.1811 17.6323 20.9444 16.9001M18.1667 21.9301C18.1667 18.9846 14.4357 16.5967 9.83333 16.5967C5.23096 16.5967 1.5 18.9846 1.5 21.9301M18.1667 12.5967C21.2349 12.5967 23.7222 10.2089 23.7222 7.26339C23.7222 4.31787 21.2349 1.93005 18.1667 1.93005M9.83333 12.5967C6.76508 12.5967 4.27778 10.2089 4.27778 7.26339C4.27778 4.31787 6.76508 1.93005 9.83333 1.93005C12.9015 1.93005 15.3889 4.31787 15.3889 7.26339C15.3889 10.2089 12.9015 12.5967 9.83333 12.5967Z",
    stroke: "url(#paint0_linear_1_846)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_846",
    x1: 1.5,
    y1: 11.9301,
    x2: 26.5,
    y2: 11.9301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02AAB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00CDAC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialsIcon);
export default __webpack_public_path__ + "static/media/SocialsIcon.12abc041e72e9d635dddb099aab1649c.svg";
export { ForwardRef as ReactComponent };